module.exports = __webpack_public_path__ + "img/pink.948c0e1d.png";